import { Button, Checkbox, Input, message } from 'antd'
import type { CheckboxChangeEvent } from 'antd/es/checkbox'
import React, { FunctionComponent, useCallback, useState } from 'react'

import { useCheckClaims } from '../../utils/useCheckClaims'

export interface SubjectSearchBarProps {
  loading?: boolean
  onSubmit: (params: {
    name: string
    address: string
    history?: boolean
  }) => void
}

export const SubjectSearchBar: FunctionComponent<SubjectSearchBarProps> =
  props => {
    const [name, setName] = useState('')
    const [address, setAddress] = useState('')
    const [history, setHistory] = useState(false)

    const tester = useCheckClaims('ApiVyvojar')
    const handleName = (e: React.ChangeEvent<HTMLInputElement>) =>
      setName(e.target.value)
    const handleAddress = (e: React.ChangeEvent<HTMLInputElement>) =>
      setAddress(e.target.value)
    const handleHistory = (e: CheckboxChangeEvent) =>
      setHistory(e.target.checked)

    const handleSearch = useCallback(() => {
      if (!name) {
        message.error(`Jméno subjektu je povinné.`)
      } else props.onSubmit({ name, address, history })
    }, [name, props, address, history])

    return (
      <div className="flex space-x-2 py-6">
        <Input
          disabled={props.loading}
          className="w-full"
          size="large"
          placeholder="Jméno/název subjektu"
          value={name}
          onChange={handleName}
          onPressEnter={handleSearch}
          autoFocus
        />
        <Input
          disabled={props.loading}
          className="w-full"
          size="large"
          placeholder="Adresa, nebo její část (nepovinné)"
          value={address}
          onChange={handleAddress}
          onPressEnter={handleSearch}
        />
        {tester && (
          <Checkbox
            disabled={props.loading}
            checked={history}
            onChange={handleHistory}
          >
            Zahrnout historii
          </Checkbox>
        )}
        <Button
          loading={props.loading}
          size="large"
          disabled={!name}
          type="primary"
          onClick={handleSearch}
        >
          Vyhledat subjekt
        </Button>
      </div>
    )
  }
